import styled from "styled-components";
import { colors } from "../../../theme/color";
import fipayFonts from "../../../theme";

export const PaymentLinkSideBarContainer = styled.div`
  height: 100vh;
  position: fixed;
  background-color: #ffffff;
  width: 14.375rem;
  z-index: 9999;
  @media only screen and (max-width: 767px) {
    border-right: 1px solid ${colors.general.brightGray};
    width: 16.6875rem;
    top: 0;
    left: 0;
  }
`;

export const ImageCon = styled.div`
  margin-top: 33px;
  margin-left: 50px;
  @media only screen and (max-width: 767px) {
    margin-left: 0px;
    margin-top: 19px;
  }
`;

export const SideBarContent = styled.div<{
  active: boolean;
  currentRoute: string;
}>`
  display: flex;
  padding: 15px 0px;
  cursor: pointer;
  position: relative;
  background: ${({ active }) =>
    active
      ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
      : "none"};

  /* Bar on the left to replace border-left */
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background-color: ${({ active }) => (active ? "#00C703" : "none")};
    border-radius: 0px 8px 8px 0px;
  }

  img {
    padding-left: 44px;
    @media only screen and (max-width: 767px) {
      padding-left: 1.75rem;
    }
  }
`;

export const Span = styled.span`
  padding-left: 10px;
  color: ${colors.DARK_GRAY};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const MainMenuText = styled.div`
  margin-left: 54px;
  margin-top: 40px;
  margin-bottom: 22px;
  @media only screen and (max-width: 767px) {
    margin-left: 1.75rem;
  }
`;

export const SpanHead = styled.span`
  color: ${colors.LIGHT_GREY};
  line-height: 15.22px;
`;

export const SpanBottom = styled.span`
  padding-left: 10px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  color: ${colors.DANGER};
`;

export const LogOutText = styled.div`
  position: absolute;
  bottom: 25px;
  margin-left: 45px;
  display: flex;
  cursor: pointer;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 2.5%;
  right: 4%;
`;

export const XIcon = styled.img`
  display: none;
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    display: flex;
    width: 2rem;
  }
`;

export const FipayLogo = styled.img`
  display: flex;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const FipayMobileLogo = styled.img`
  display: none;
  @media only screen and (max-width: 767px) {
    display: flex;
    margin-left: 1.75rem;
  }
`;
